import { validationIsEqual } from '../status';
import { validateAlphaNumericString } from '@om/validation';
import {
    AGENT_NAME_SET_VALUE,
    AGENT_CODE_SET_VALUE,
    setNameValid,
    setAgentCodeValid,
} from '../../../actions/ugMotorInsurance/motorAgentModal';

let prevValidationAction = null;

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const agentModalFormValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;

        const validateNameWithExtraSpaces = (value) => {
            let customError = null;

            if (value) {
                const formattedValue = value.replace(/\s{2,}/g, ' ');

                customError = validateAlphaNumericString(formattedValue, {
                    min: 2,
                    max: 48,
                    subject: 'Name',
                });
            }

            return customError;
        };
        switch (action.type) {
            case AGENT_NAME_SET_VALUE:
                error = validateNameWithExtraSpaces(gatsbyStack === 'ug' ? action.value?.value : action.value.name);
                return setNameValid(error);

            case AGENT_CODE_SET_VALUE:
                /*
                error = validateAlphaNumericString(action.value, {
                    subject: 'Agent Code',
                    min: 3,
                });*/
                return setAgentCodeValid(error);

            default:
                return null;
        }
    })();
    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
